import { FC } from "react";
import {
  AddressSearch,
  BusinessUnitSearch,
} from "../../components/LocationSearch";
import {
  DeliveryType,
  LocationInterface,
  BusinessUnitInterface,
} from "../../interfaces";
import { FormSimpleRadioGroup } from "../../components/FormFields";
import { AutocompleteRegion } from "../../components/Form/FormMapsAutocomplete";
import { useAppSelector } from "../../store/hooks";

interface LocationSelectProps {
  deliveryType?: DeliveryType;
  selectedLocation?: LocationInterface;
  selectedBusinessUnit?: BusinessUnitInterface;
  buSource?: BusinessUnitInterface;
  setLocationType: (type: DeliveryType) => void;
  setLocation: (
    location?: LocationInterface,
    businessUnit?: BusinessUnitInterface
  ) => void;
}
const LocationSelect: FC<LocationSelectProps> = ({
  deliveryType,
  selectedLocation,
  selectedBusinessUnit,
  buSource,
  setLocationType,
  setLocation,
}) => {
  const businessUnits = useAppSelector(
    (state) => state.inmutable.businessUnits
  );

  return (
    <div className="flex flex-col bg-white gap-2">
      <FormSimpleRadioGroup
        horizontal
        name="deliveryType"
        selected={deliveryType}
        onSelectOption={(type) => {
          setLocationType(type);
        }}
        options={[
          { value: DeliveryType.AT_OFFICE, name: "Tienda" },
          { value: DeliveryType.AT_HOME, name: "Domicilio" },
        ]}
        description="Buscar por:"
      />

      {deliveryType === DeliveryType.AT_OFFICE && (
        <BusinessUnitSearch
          buSource={buSource}
          selected={selectedBusinessUnit}
          setSelectedLocation={(businessUnit) =>
            setLocation(businessUnit.location, businessUnit)
          }
        />
      )}
      {deliveryType === DeliveryType.AT_HOME && (
        <AddressSearch
          businessUnits={businessUnits}
          selected={selectedLocation}
          region={AutocompleteRegion.TEALCA}
          setSelectedLocation={(location, businessUnit) => {
            setLocation(location, businessUnit);
          }}
        />
      )}

      {deliveryType === DeliveryType.INTERNATIONAL && (
        <AddressSearch
          businessUnits={businessUnits}
          selected={selectedLocation}
          region={AutocompleteRegion.INTERNATIONAL}
          setSelectedLocation={(location, businessUnit) =>
            setLocation(location, businessUnit)
          }
        />
      )}
    </div>
  );
};

export default LocationSelect;
